export enum AssetCondition {
  Unknown = 'unknown',
  Available = 'available',
  PendingEstimate = 'pending_estimate',
  PendingRepair = 'pending_repair',
  Damaged = 'damaged',
}
